export default "<div id=\"map\" class=\"map\" #visjsMap></div>\r\n"